import { Grid, TextField } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { DateTimeRangePickerProps } from './interface';
import moment from 'moment';

const DateTimeRangePicker = (props: DateTimeRangePickerProps) => {
  const { endText, startText, onChange, value } = props;
  const theme = useTheme();

  const handleStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = event.target.value;
    if (dateValue) {
      const newDate = moment(dateValue);
      if (value[0]) {
        const combined = newDate
          .hour(value[0].hour())
          .minute(value[0].minute())
          .second(value[0].second());
        onChange([combined, value[1]]);
      } else {
        onChange([newDate, value[1]]);
      }
    } else {
      onChange([null, value[1]]);
    }
  };

  const handleStartTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const timeValue = event.target.value;
    if (timeValue && value[0]) {
      const [hours, minutes] = timeValue.split(':');
      const newDateTime = value[0].clone()
        .hour(parseInt(hours))
        .minute(parseInt(minutes));
      onChange([newDateTime, value[1]]);
    } else if (!timeValue && value[0]) {
      const resetTime = value[0].clone().hour(0).minute(0).second(0);
      onChange([resetTime, value[1]]);
    }
  };

  const handleEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = event.target.value;
    if (dateValue) {
      const newDate = moment(dateValue);
      if (value[1]) {
        const combined = newDate
          .hour(value[1].hour())
          .minute(value[1].minute())
          .second(value[1].second());
        onChange([value[0], combined]);
      } else {
        onChange([value[0], newDate]);
      }
    } else {
      onChange([value[0], null]);
    }
  };

  const handleEndTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const timeValue = event.target.value;
    if (timeValue && value[1]) {
      const [hours, minutes] = timeValue.split(':');
      const newDateTime = value[1].clone()
        .hour(parseInt(hours))
        .minute(parseInt(minutes));
      onChange([value[0], newDateTime]);
    } else if (!timeValue && value[1]) {
      const resetTime = value[1].clone().hour(23).minute(59).second(59);
      onChange([value[0], resetTime]);
    }
  };

  return (
    <Grid item display={"flex"} alignItems={"center"} flexDirection={"row"} flexWrap={"wrap"}>
      <Grid item display={"flex"} flexDirection={"row"} marginBottom={2}>
        <TextField 
          label={startText}
          type="date"
          value={value[0] ? value[0].format('YYYY-MM-DD') : ''}
          onChange={handleStartDateChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3
            }
          }}
        />
        <TextField
          label={`${startText} час`}
          type="time"
          value={value[0] ? value[0].format('HH:mm') : ''}
          onChange={handleStartTimeChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3
            }
          }}
        />
      </Grid>
      &nbsp;&nbsp;&nbsp;{'-'}&nbsp;&nbsp;&nbsp;
      <Grid item display={"flex"} flexDirection={"row"} marginBottom={2}>
        <TextField 
          label={endText}
          type="date"
          value={value[1] ? value[1].format('YYYY-MM-DD') : ''}
          onChange={handleEndDateChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3
            }
          }}
        />
        <TextField
          label={`${endText} час`}
          type="time"
          value={value[1] ? value[1].format('HH:mm') : ''}
          onChange={handleEndTimeChange}
          size="small"
          InputLabelProps={{ shrink: true }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              borderRadius: 3
            }
          }}
        />
      </Grid>
    </Grid>
  );
};

export default DateTimeRangePicker;
